import React from 'react';

import Button from '../../../components/ui/Button';

const BulkActionsBar = ({ selectedCount, onBulkAction, onClearSelection }) => {
  if (selectedCount === 0) return null;

  const bulkActions = [
    {
      id: 'generate-invoice',
      label: 'Generate Invoices',
      icon: 'FileText',
      variant: 'primary'
    },
    {
      id: 'send-reminder',
      label: 'Send Reminders',
      icon: 'Send',
      variant: 'outline'
    },
    {
      id: 'mark-paid',
      label: 'Mark as Paid',
      icon: 'CheckCircle',
      variant: 'success'
    },
    {
      id: 'export-selected',
      label: 'Export Selected',
      icon: 'Download',
      variant: 'outline'
    }
  ];

  return (
    <div className="fixed bottom-6 left-1/2 transform -translate-x-1/2 z-50">
      <div className="bg-surface border border-border rounded-lg shadow-elevation-3 p-4 min-w-max">
        <div className="flex items-center space-x-4">
          {/* Selection Info */}
          <div className="flex items-center space-x-2">
            <div className="w-8 h-8 bg-accent rounded-full flex items-center justify-center">
              <span className="text-sm font-medium text-accent-foreground">
                {selectedCount}
              </span>
            </div>
            <span className="text-sm font-medium text-text-primary">
              {selectedCount} record{selectedCount !== 1 ? 's' : ''} selected
            </span>
          </div>

          {/* Divider */}
          <div className="w-px h-6 bg-border"></div>

          {/* Bulk Actions */}
          <div className="flex items-center space-x-2">
            {bulkActions.map((action) => (
              <Button
                key={action.id}
                variant={action.variant}
                iconName={action.icon}
                iconPosition="left"
                onClick={() => onBulkAction(action.id)}
                className="text-sm"
              >
                {action.label}
              </Button>
            ))}
          </div>

          {/* Clear Selection */}
          <div className="w-px h-6 bg-border"></div>
          <Button
            variant="ghost"
            iconName="X"
            onClick={onClearSelection}
            className="p-2"
          />
        </div>
      </div>
    </div>
  );
};

export default BulkActionsBar;